export default __webpack_public_path__ + "static/media/bmw-astra.af651e18.svg";